import React, { useCallback } from 'react';
import classnames from 'classnames';
import { ModelListEditor } from '@leverege/ui-plugin';
import { Button, Flex, List, TextInput } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import Model from "../model/FiltersAggModel.js";
import FilterAggModel from "../model/FilterAggModel.js";
import S from '../Shared.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.dataViewers.aggregations.FiltersAggEditor');
export default function FiltersAggEditor(props) {
  const {
    value,
    className,
    onChange,
    eventData,
    objectType,
    delegate,
    relationship
  } = props;
  const onAddFilter = useCallback(({
    data
  }) => {
    const filtersCount = value.filters ? Object.keys(value.filters).length : 0;
    const filterModel = FilterAggModel.create({
      name: t('filterCount', {
        filtersCount: filtersCount + 1
      })
    });
    const nModel = Model.addFilter(value, filterModel);
    onChange({
      data: eventData,
      value: nModel
    });
  }, [value]);
  const header = () => {
    return /*#__PURE__*/_jsx(Flex, {
      align: "center",
      justify: "space-between",
      children: /*#__PURE__*/_jsx(Button, {
        variant: "tertiary",
        icon: tIcon('iconAdd', 'fa fa-plus'),
        eventData: "setFilters",
        onClick: onAddFilter,
        children: t('addButtonText')
      })
    });
  };
  const forward = useCallback(e => {
    const nModel = Model.setFilters(value, e.value.filters);
    onChange({
      value: nModel,
      data: eventData
    });
  }, [onChange, eventData, value]);
  return /*#__PURE__*/_jsx("div", {
    className: classnames(S.editor, className),
    children: /*#__PURE__*/_jsx(ModelListEditor, {
      listHeader: header,
      value: value,
      model: Model.filters(),
      eventData: "setFilters",
      onChange: forward,
      selectedProps: {
        delegate,
        relationship,
        objectType
      },
      itemProps: {
        onChange,
        value,
        eventData
      },
      renderer: ListRenderer
    })
  });
}
function ListRenderer(props) {
  const {
    item,
    onEvent,
    deleteable = true,
    onChange,
    eventData,
    value,
    ...rest
  } = props;
  const onDelete = deleteable ? e => {
    // eslint-disable-next-line react/destructuring-assignment
    onEvent({
      type: 'child.remove',
      item,
      data: props.eventData
    });
  } : null;
  const onChangeKey = ({
    value: newKey,
    data: oldKey
  }) => {
    const idx = Model.indexOfFilter(value, item);
    const val = {
      ...item,
      name: newKey
    };
    const nModel = Model.setFilter(value, idx, val);
    onChange({
      value: nModel,
      data: eventData
    });
  };
  return /*#__PURE__*/_jsx(List.Item, {
    item: item,
    ...rest,
    children: /*#__PURE__*/_jsxs(Flex, {
      variant: "rowM",
      justify: "space-between",
      align: "center",
      children: [/*#__PURE__*/_jsx(TextInput, {
        eventData: item.name,
        variant: "listItemSubtitle",
        value: item.name,
        onChange: onChangeKey
      }), deleteable && /*#__PURE__*/_jsx(Button, {
        variant: "link",
        eventData: item,
        onClick: onDelete,
        icon: tIcon('iconDelete', 'fa fa-trash')
      })]
    })
  });
}